// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qrcode-wrapper[data-v-5fad9046] {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 1.5rem;\n}\n.qr-placeholder[data-v-5fad9046] {\n  width: 256px;\n  height: 256px;\n  border-radius: 6px;\n  background-color: #f5f5f5;\n}", ""]);
// Exports
module.exports = exports;
